export const tabClicked = (activeTab: any = 1 , pageNumber: any = 1) => ({
    type: 'tabClicked',
    pageTabState: {
        activeTab: activeTab,
        pageNumber: pageNumber,
    }
});